/**
 *
 * @module mediaClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class MediaClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc A model containing the MediaClient's configuration settings.
 *
 */
export default class MediaClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/media/mediaClientConfiguration.js